const DISPLAY_REMAINING_DAYS = false;

export const messages = {
  submitMessageFun: (data) => {
    if (DISPLAY_REMAINING_DAYS)
      return `<span>The EDA will get back to you within <b>${data} working days.</b></span>`;
    else return "";
  },
};
